import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProofFileModel } from '@shared/models/file.model';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent {
  @Input() files!: ProofFileModel[] | null;
  @Output() uploadFile: EventEmitter<FileList> = new EventEmitter<FileList>();
  @Output() deleteFile: EventEmitter<string> = new EventEmitter<string>();
  public allowedExtensions: string = 'image/png, image/jpeg';

  public onFileChange(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const fileList = element.files;
    if (fileList && fileList.length) {
      this.uploadFile.emit(fileList);
    }
  }

  public onFileDelete(id: string) {
    this.deleteFile.emit(id);
  }
}
